import { render, staticRenderFns } from "./salesTableSh.vue?vue&type=template&id=f36cd6ba&scoped=true"
import script from "./salesTableSh.vue?vue&type=script&lang=js"
export * from "./salesTableSh.vue?vue&type=script&lang=js"
import style0 from "./salesTableSh.vue?vue&type=style&index=0&id=f36cd6ba&prod&scoped=true&lang=css"
import style1 from "./salesTableSh.vue?vue&type=style&index=1&id=f36cd6ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f36cd6ba",
  null
  
)

export default component.exports